// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M8.64494 20.5C9.07521 21.9457 10.4145 23 12 23C13.5855 23 14.9248 21.9457 15.3551 20.5H8.64494Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M3 19.5H21V16.5L19 13.5V8.5C19 4.63401 15.866 1.5 12 1.5C8.13401 1.5 5 4.63401 5 8.5V13.5L3 16.5V19.5Z"}}]};

const NotificationFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'notification-filled',
    ref,
    icon: element,
  },
));

NotificationFilledIcon.displayName = 'NotificationFilledIcon';

export default NotificationFilledIcon;
